import * as React from 'react'
import { DriverCardsRow } from './DriverCardsRow'
import DriverCardsActions from './DriverCardsActions'
import TableTitle from '@/modules/drivers/shared/tableItems/TableTitle'
import { TableHeader } from '@/modules/drivers/shared/tableItems/TableHeader'
import { useSortableData } from '@/modules/drivers/hooks/useSortTable'
import { useTable } from '@/modules/drivers/context/TableContext'
import { getDriverCardsColumns } from '@/modules/drivers/constants/tables'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
const DriverCardsTable = ({
  cards,
  companyId,
  driverId,
}: {
  cards: any[]
  companyId: string
  driverId: number
}) => {
  const { t } = useLocalize()
  const columns = getDriverCardsColumns(t)
  const { toggleAll, toggleId, selectedGroup, isSelectedAny } = useTable()

  const { sortedData, sortConfig, handleHeaderClick } = useSortableData({
    data: cards,
    tableColumns: columns,
  })

  return (
    <div className="tw-pb-4">
      {/* <TableTitle title="driverData.contracts" /> */}

      {isSelectedAny ? (
        <DriverCardsActions companyId={companyId} driverId={driverId} />
      ) : (
        <TableTitle title={t('driverModule.driver-digital-cards')} />
      )}
      <div
        className={`tw-overflow-x-auto tw-rounded-lg tw-border tw-border-x-base-300 tw-border-t-base-300 ${isSelectedAny && 'tw-rounded-t-none'}`}
      >
        <table className="tw-w tw-w-full tw-table-auto tw-border-collapse !tw-rounded-3xl tw-pt-2">
          <TableHeader
            columns={columns}
            fontSize="md"
            isSelectedAny={isSelectedAny}
            rounded
            sortConfig={sortConfig}
            bolder
            disabledToggle={true}
            toggleAll={toggleAll}
            onHeaderClick={handleHeaderClick}
          />

          <tbody>
            {sortedData.map((card, i) => (
              <DriverCardsRow
                key={card.id ?? i}
                card={card}
                selectedIds={selectedGroup?.ids ?? []}
                toggleId={toggleId}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default DriverCardsTable
